const specConfig = {
  URL: process.env.REACT_APP_API_URL
}

export const config = {
  ...specConfig
};
